import React, {Fragment, useState} from 'react'
import {connect} from 'dva'
import {routerRedux} from 'dva/router'
import moment from 'moment'
import {parse} from 'query-string'
import {Button, DatePicker, Divider, Form, Icon, Input, message, Modal, Radio, Select, Spin} from 'antd'
import styles from "./index.module.less"
import alipay from "../../assets/alipay.png"
import warning from "../../assets/warning.png"
import {contextPath} from "../../utils/config"

const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 10
  },
}
const tailFormItemLayout = {
  wrapperCol: {
    span: 12,
    offset: 8,
  },
}

const namespace = 'ticketsubmit'


const required = {
  required: true,
  message: '不能为空！',
}

const maxLength = {
  max: 200,
  message: '不能超过200个字符',
}

const Component = ({
                     model,
                     app,
                     loading,
                     location,
                     dispatch,
                     form: {
                       getFieldDecorator,
                       validateFieldsAndScroll,
                       setFieldsValue,
                       getFieldsValue,
                     },
                   }) => {

  location.query = parse(location.search)
  const formLoading = !!loading.effects[`${namespace}/submit`]
  const {showSuccess, product, orderId, totalAmount, inventory, freeTicketCartTypes} = model
  const [quantity, setQuantity] = useState(1)
  const [editVisitorIndex, setEditVisitorIndex] = useState(null)
  const [feedbackVisible, setFeedbackVisible] = useState(false)
  const {datePriceList = [], freeTicket} = product
  const datePrices = {}
  const fieldsValue = getFieldsValue()
  const visitor = fieldsValue['visitorList'] && fieldsValue['visitorList'][editVisitorIndex]

  datePriceList
    .filter(datePrice => datePrice.salePrice !== 99) // 规定99元代表禁用当日售票
    .filter(datePrice => datePrice.gardenClosed !== 1) // 闭园
    .forEach(datePrice => datePrices[parseInt(datePrice.date, 10)] = datePrice.salePrice)

  const disabledDate = (current) => {
    const price = datePrices[current.startOf('day').toDate().getTime()]
    if (price !== undefined) {
      return current && current < moment().endOf('day');
    }
    return true;
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    validateFieldsAndScroll((errors, {
      quantity,
      travelDate,
      visitorList,
      ...values
    }) => {
      if (errors) {
        return false
      }
      if (quantity > inventory) {
        message.error('预约已满！');
        return
      }
      dispatch({
        type: `${namespace}/submit`,
        payload: {
          ...values,
          quantity,
          travelDate: travelDate.startOf('day'),
          visitorInfoList: visitorList,
          mobile: app.user.phoneNo,
          contact: visitorList[0].name,
          productId: product.productId,
          price: product.price,
        },
      })
    })
  }

  const handleBack = () => {
    dispatch(routerRedux.push({
      pathname: `/ticket`,
    }))
  }

  const onQuantityChange = (v) => {
    setQuantity(v)
  }

  const onTravelDateChange = (v) => {
    refreshInventory(v)
  }

  const refreshInventory = (v) => {
    v && dispatch({
      type: `${namespace}/refreshInventory`,
      payload: {
        productId: product.productId,
        travelDate: v,
      },
    })
  }

  const onEditVisitor = (index) => {
    setEditVisitorIndex(index)
  }

  const visitorModalProps = {
    visible: editVisitorIndex !== null,
    item: visitor,
    freeTicket,
    freeTicketCartTypes,
    onSubmit(data) {
      setFieldsValue({
        [`visitorList[${editVisitorIndex}]`]: data
      })
      setEditVisitorIndex(null)
    },
    onCancel() {
      setEditVisitorIndex(null)
    },
  }

  const feedbackModalProps = {
    visible: feedbackVisible,
    onSubmit() {
      dispatch(routerRedux.replace({
        pathname: `/ticket/order/${orderId}`,
      }))
    },
    onCancel() {
      setFeedbackVisible(false)
    },
  }

  function getInventoryContent() {
    const inventoryLoading = loading.effects[`${namespace}/refreshInventory`]
    if (inventoryLoading) {
      return <Spin spinning/>
    }
    if (inventory === undefined) {
      return
    }
    return <div>{inventory === null ? <span style={{color: '#ff5555'}}>无法获取当日库存信息</span> :
      <span>当日库存：{inventory} 张</span>} <a
      onClick={() => refreshInventory(getFieldsValue()['travelDate'])}
    > &nbsp;<Icon type="sync"/></a></div>
  }

  return (
    <div className={styles['page-submit']}>
      {showSuccess ?
        <Fragment>
          <h1>订单提交成功，请尽快付款！</h1>
          <Divider/>
          <Form {...formItemLayout} name="payment" className={styles['result-form']}
                onSubmit={() => {
                  setFeedbackVisible(true)
                }}
                action={`${contextPath}/ticket/order/pay`} method="post" target="_blank">
            <Form.Item label="您的订单号">
              <span className={styles['result-text']}>{orderId}</span>
              <input type="hidden" name="orderId" value={orderId}/>
            </Form.Item>
            <Form.Item label="需支付金额"><span className={styles['result-text']}>{`¥${totalAmount}`}</span> 元</Form.Item>
            <Form.Item label="支付方式">
              {getFieldDecorator('payType', {
                initialValue: 1,
              })(<Radio.Group name="payType">
                <Radio value={1}>
                  <img alt="支付宝支付" style={{width: 100}} src={alipay}/>
                </Radio>
              </Radio.Group>)}
            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" size="large" htmlType="submit">
                立即支付
              </Button>
            </Form.Item>
          </Form>
        </Fragment> :
        <Fragment>
          <h1>票务相关内容</h1>
          <Divider/>
          <Spin spinning={formLoading}>
            <Form {...formItemLayout} style={{marginTop: 20}} onSubmit={handleSubmit}>
              <div className={styles.legend}>
                购票信息
              </div>
              <Form.Item label="当前票种" required>
                <div className={styles['product-title']}>{product.title}</div>
                <div className={styles['product-desc']}>{product.description}</div>
              </Form.Item>
              <Form.Item label="购买票数">
                {getFieldDecorator('quantity', {
                  initialValue: 1,
                  rules: [
                    required,
                  ],
                  onChange: onQuantityChange
                })(
                  <Select style={{width: 72}}>
                    {[1, 2, 3].map(v => <Select.Option value={v}>{v}</Select.Option>)}
                  </Select>
                )} &nbsp;&nbsp;&nbsp;&nbsp;张
              </Form.Item>
              <Form.Item label="入园日期">
                {getFieldDecorator('travelDate', {
                  rules: [
                    required,
                  ],
                  onChange: onTravelDateChange,
                })(
                  <DatePicker disabledDate={disabledDate}
                              placeholder="请选择入园日期"
                              style={{width: '100%'}}
                              showToday={false}
                              allowClear={false}
                              dropdownClassName={styles['travel-date-picker']}
                              dateRender={current => {
                                const price = datePrices[current.startOf('day').toDate().getTime()]
                                return <div className="ant-calendar-date">
                                  <span className="travel-date">{current.date()}</span>
                                  <span className="travel-date-price">{price === undefined ? '' : `¥ ${price}`}</span>
                                </div>
                              }}
                  />)}

                {getInventoryContent()}
              </Form.Item>

              <div className={styles.legend}>
                购票人信息
              </div>

              {
                [...new Array(quantity).keys()]
                  .map(index => <Form.Item label={`入园人${index + 1}`} required>
                    {getFieldDecorator(`visitorList[${index}]`, {
                      rules: [
                        {
                          required: true,
                          message: '请填写入园人信息！',
                        },
                      ],
                    })(
                      fieldsValue['visitorList'] && fieldsValue['visitorList'][index] ? <span>
                        {fieldsValue['visitorList'][index].phone} &nbsp;<a onClick={() => onEditVisitor(index)}><Icon
                        type="edit"/>修改</a>
                      </span> : <Button size="small" icon="edit" onClick={() => onEditVisitor(index)}>填写入园人信息</Button>)}
                  </Form.Item>)
              }

              <Form.Item {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit">
                  确认提交
                </Button> &nbsp;
                <Button type="default" htmlType="button" onClick={handleBack}>
                  返回
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Fragment>
      }
      {visitorModalProps.visible && <VisitorModal {...visitorModalProps}/>}
      {feedbackVisible && <FeedbackModal {...feedbackModalProps}/>}
    </div>
  )
}

const VisitorModal = Form.create()(
  ({
     item = {},
     freeTicket,
     freeTicketCartTypes,
     onSubmit,
     form: {
       getFieldDecorator,
       validateFieldsAndScroll,
     },
     ...props
   }) => {
    const handleSubmit = () => {
      validateFieldsAndScroll((errors, {
        cardType,
        ...values
      }) => {
        if (errors) {
          return
        }
        onSubmit({
          cardType: cardType === undefined ? 1 : parseInt(cardType, 10),
          ...values,
        })
      })
    }

    const modalOpts = {
      title: '填写入园人信息',
      maskClosable: false,
      ...props,
      onOk: handleSubmit,
    }
    return <Modal {...modalOpts}>
      <Form {...formItemLayout}>
        {/*<Form.Item label="姓名">*/}
        {/*  {getFieldDecorator('name', {*/}
        {/*    initialValue: item.name,*/}
        {/*    rules: [*/}
        {/*      {*/}
        {/*        required: true,*/}
        {/*        message: '请输入姓名',*/}
        {/*      },*/}
        {/*    ],*/}
        {/*  })(<Input placeholder="请输入姓名"/>)}*/}
        {/*</Form.Item>*/}
        <Form.Item label="手机号码">
          {getFieldDecorator('phone', {
            initialValue: item.phone,
            rules: [
              {
                required: true,
                message: '请输入手机号码',
              },
              {
                pattern: /^1[3456789][0-9]{9}$/,
                message: '请输入有效的手机号码',
              }
            ],
          })(<Input placeholder="请输入手机号码"/>)}
        </Form.Item>
        {/*<Form.Item label="身份证号码">*/}
        {/*  {getFieldDecorator('cardNo', {*/}
        {/*    initialValue: item.cardNo,*/}
        {/*    rules: [*/}
        {/*      {*/}
        {/*        required: true,*/}
        {/*        message: '请输入身份证号码',*/}
        {/*      },*/}
        {/*      {*/}
        {/*        pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,*/}
        {/*        message: '身份证号码格式不正确',*/}
        {/*      }*/}
        {/*    ],*/}
        {/*  })(<Input placeholder="请输入身份证号码"/>)}*/}
        {/*</Form.Item>*/}
        {freeTicket === 1 && <Form.Item label="票类型">
          {getFieldDecorator('cardType', {
            initialValue: item.cardType,
            rules: [
              {
                required: true,
                message: '请选择票类型',
              },
            ],
          })(<Select placeholder="请选择票类型">
            {
              freeTicketCartTypes.map(cardType => <Select.Option key={cardType.id} value={cardType.id}>
                {cardType.description}
              </Select.Option>)
            }
          </Select>)}
        </Form.Item>}
      </Form>
    </Modal>
  }
)

const FeedbackModal = ({
                         onCancel,
                         onSubmit,
                         ...props
                       }) => {

  const modalOpts = {
    title: '支付提示',
    maskClosable: false,
    onCancel,
    footer: false,
    ...props,
  }
  return <Modal {...modalOpts}>
    <div className={styles.feedback}>
      <img src={warning}/>
      <h2>请在新打开的页面完成支付 <br/> 支付完成前请不要关闭窗口。</h2>
      <Button type="primary" size="large" onClick={onSubmit}>已完成支付</Button>&nbsp;&nbsp;&nbsp;&nbsp;
      <a onClick={onCancel}>支付遇到问题？</a>
    </div>
  </Modal>
}

export default connect(({ticketsubmit, app, loading}) => ({
  loading,
  app,
  model: ticketsubmit,
}))(Form.create()(Component))
